import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value", "feedback"]

  copy(event) {
    event.preventDefault()

    const text = this.valueTarget.textContent.trim()
    if (!text) return

    const success = () => this.showFeedback()

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(success).catch(() => this.fallbackCopy(text, success))
    } else {
      this.fallbackCopy(text, success)
    }
  }

  fallbackCopy(text, callback) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand("copy")
      callback()
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showFeedback() {
    if (!this.hasFeedbackTarget) return

    this.feedbackTarget.classList.remove("hidden")
    if (this.hideTimer) clearTimeout(this.hideTimer)
    this.hideTimer = setTimeout(() => {
      this.feedbackTarget.classList.add("hidden")
    }, 2000)
  }
}
